// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import ChangeYearController from "./change_year_controller";
application.register("change-year", ChangeYearController);

import ClipboardController from "./clipboard_controller";
application.register("clipboard", ClipboardController);

import GalleryController from "./gallery_controller";
application.register("gallery", GalleryController);

import HideRemoveCatController from "./hide_remove_cat_controller";
application.register("hide-remove-cat", HideRemoveCatController);

import JumpListController from "./jump_list_controller";
application.register("jump-list", JumpListController);

import MapController from "./map_controller";
application.register("map", MapController);

import PersonController from "./person_controller";
application.register("person", PersonController);

import QuantityController from "./quantity_controller";
application.register("quantity", QuantityController);

import SelectController from "./select_controller";
application.register("select", SelectController);

import SetHrefController from "./set_href_controller";
application.register("set-href", SetHrefController);

import SetInputController from "./set_input_controller";
application.register("set-input", SetInputController);

import SlimSelectController from "./slim_select_controller";
application.register("slim-select", SlimSelectController);

import TabsController from "./tabs_controller";
application.register("tabs", TabsController);

import TurnstileController from "./turnstile_controller";
application.register("turnstile", TurnstileController);
